import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorTitle: {
    id: 'fG46qD',
    defaultMessage: 'Error while fetching mappings',
    description: 'Error header after unsuccessful fetching of mappings for csv import',
  },
  errorContent: {
    id: 'MEaBey',
    defaultMessage: 'An error occurred while fetching mappings. Please try again later.',
    description: 'Error content after unsuccessful fetching of mappings for csv import',
  },
});
